export default __webpack_public_path__ + "static/media/hht2_direction_eggstudio_03.e98365ce.jpg";